export default __webpack_public_path__ + "static/media/sideLogo.2162f9dd.png";